import { useTranslations } from '@power-core/toolkit';
import { useEffect, useRef, useState } from 'react';

import { useDate } from '@/modules/utils/custom-hooks/use-date';

export const useDropdown = () => {
	const [searchTerm, setSearchTerm] = useState('');
	const [userTyped, setUserTyped] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [isAbove, setIsAbove] = useState(false);
	const dropdownRef = useRef<HTMLDivElement>(null);
	const { format } = useDate();

	const t = useTranslations();

	useEffect(() => {
		const handlePosition = () => {
			if (dropdownRef.current) {
				const rect = dropdownRef.current.getBoundingClientRect();
				const spaceBelow = window.innerHeight - rect.bottom;
				const spaceAbove = rect.top;

				if (spaceBelow < 200 && spaceAbove > spaceBelow) {
					setIsAbove(true);
				} else {
					setIsAbove(false);
				}
			}
		};

		window.addEventListener('resize', handlePosition);
		handlePosition();

		return () => {
			window.removeEventListener('resize', handlePosition);
		};
	}, [isOpen]);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return {
		t,
		format,
		searchTerm,
		setSearchTerm,
		isOpen,
		setIsOpen,
		userTyped,
		setUserTyped,
		isAbove,
		dropdownRef,
	};
};
